import DapDSBanner from './banner.component'

export * from './banner.component'
export default DapDSBanner

DapDSBanner.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-banner': DapDSBanner
  }
}
